import React from "react";
import {
  Box,
  Button,
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
} from "@mui/material";
import {
  MenuItemsForDropDown,
  NameField,
  SurnameField,
  IDTypeSelectComponent,
  TaxTypeSelectComponent,
  TaxNumberComponent,
  IDNumberComponent,
  EmailFieldComponent,
  PassportComponent,
} from "@soqs/common";

import { useSelector } from "react-redux";
import {
  dropdownopts,
  dropdownsloading,
  formState,
} from "../../features/AppSlice";

import SelectComponent from "./usercomponents/SelectComponent";
import DateSelectorComponent from "./usercomponents/DateSelectorComponent";
import PostalCode from "./usercomponents/Address/PostalCodeComponent";
import AddressUnitNumber from "./usercomponents/Address/AddressUnitNumber";
import AddressComplexName from "./usercomponents/Address/AddressComplexName";
import AddressStreetName from "./usercomponents/Address/AddressStreetName";
import AddressSuburb from "./usercomponents/Address/AddressSuburbComponent";
import AddressCity from "./usercomponents/Address/AddressCityComponent";
import TrustsMobileField from "./usercomponents/TrustsMobileField";
import BODescription from "./usercomponents/BODescription";

const BOIndividualDetails = (props) => {
  const dropdownloading = useSelector(dropdownsloading);
  const dropdownoptions = useSelector(dropdownopts);
  const formData = useSelector(formState);

  return formData.values?.bo_individuals[props.index].bo_individual_unnamed !==
    true ? (
    <>
      <Box sx={{ display: { xs: "block", md: "none" } }}>
        <Button>
          <u>{`Individual  ${props.index + 1}`}</u>
        </Button>
        <SelectComponent
          label="Ownership Type"
          name={`${props.name}.bo_individual_botype`}
          required={true}
          options={MenuItemsForDropDown(
            "individualbeneficialownershiptype",
            dropdownoptions
          )}
          optionsloading={dropdownloading}
        />
        <NameField
          index={props.index}
          label="Name"
          name={`${props.name}.bo_individual_name`}
          aria-label="Indivdual Name"
          required={true}
        />
        <SurnameField
          label="Surname"
          name={`${props.name}.bo_individual_surname`}
          required={true}
        />
        <SelectComponent
          label="Place of Birth"
          name={`${props.name}.bo_individual_placeofbirth`}
          required={true}
          options={MenuItemsForDropDown("country", dropdownoptions, false)}
          optionsloading={dropdownloading}
        />
        <SelectComponent
          label="Country of Residence"
          name={`${props.name}.bo_individual_country`}
          required={true}
          options={MenuItemsForDropDown("country", dropdownoptions, false)}
          optionsloading={dropdownloading}
        />
        {formData.values?.bo_individuals[props.index]
          .bo_individual_collapsed ? null : (
          <>
            {formData.values?.bo_individuals[props.index]
              .bo_individual_idtype === "1" ? (
              <>
                <IDTypeSelectComponent
                  name={`${props.name}.bo_individual_idtype`}
                  idoptions={MenuItemsForDropDown("idtype", dropdownoptions)}
                  optionsloading={dropdownloading}
                />
                <IDNumberComponent
                  name={`${props.name}.bo_individual_idnumber`}
                />
                {formData.values.bo_individuals[props.index]
                  .bo_individual_taxtype !== "99" ? (
                  <>
                    <TaxTypeSelectComponent
                      name={`${props.name}.bo_individual_taxtype`}
                      taxoptions={MenuItemsForDropDown(
                        "taxtype_individual_with_no_reg",
                        dropdownoptions
                      )}
                      optionsloading={dropdownloading}
                    />
                    <TaxNumberComponent
                      name={`${props.name}.bo_individual_taxnumber`}
                    />
                  </>
                ) : (
                  <TaxTypeSelectComponent
                    name={`${props.name}.bo_individual_taxtype`}
                    taxoptions={MenuItemsForDropDown(
                      "taxtype_individual_with_no_reg",
                      dropdownoptions
                    )}
                    optionsloading={dropdownloading}
                  />
                )}
                <SelectComponent
                  label="Tax Juristiction"
                  name={`${props.name}.bo_individual_taxjuristiction`}
                  required={true}
                  options={MenuItemsForDropDown(
                    "country",
                    dropdownoptions,
                    false
                  )}
                  optionsloading={dropdownloading}
                />
                <SelectComponent
                  label="Mobile Code"
                  name={`${props.name}.bo_individual_mobilecode`}
                  required={true}
                  options={MenuItemsForDropDown(
                    "mobilecode",
                    dropdownoptions,
                    false
                  )}
                  optionsloading={dropdownloading}
                />
                <TrustsMobileField
                  name={`${props.name}.bo_individual_mobile`}
                  required={true}
                  label="Mobile Number"
                />
                <EmailFieldComponent
                  name={`${props.name}.bo_individual_email`}
                />
              </>
            ) : (
              <>
                <IDTypeSelectComponent
                  name={`${props.name}.bo_individual_idtype`}
                  idoptions={MenuItemsForDropDown("idtype", dropdownoptions)}
                  optionsloading={dropdownloading}
                />
                <PassportComponent
                  name={`${props.name}.bo_individual_passport`}
                  label="Passport Number"
                />
                <SelectComponent
                  label="Passport Country"
                  name={`${props.name}.bo_individual_passportcountry`}
                  required={true}
                  options={MenuItemsForDropDown(
                    "country",
                    dropdownoptions,
                    false
                  )}
                  optionsloading={dropdownloading}
                />
                <DateSelectorComponent
                  name={`${props.name}.bo_individual_passportdt`}
                  label="Issue Date"
                  value={new Date().setDate(new Date().getDate())}
                  maxDate={new Date().setDate(new Date().getDate())}
                  readonly={true}
                />
                <SelectComponent
                  label="Tax Juristiction"
                  name={`${props.name}.bo_individual_taxjuristiction`}
                  required={true}
                  options={MenuItemsForDropDown(
                    "country",
                    dropdownoptions,
                    false
                  )}
                  optionsloading={dropdownloading}
                />
                {formData.values.bo_individuals[props.index]
                  .bo_individual_taxtype !== "99" ? (
                  <>
                    <TaxTypeSelectComponent
                      name={`${props.name}.bo_individual_taxtype`}
                      taxoptions={MenuItemsForDropDown(
                        "taxtype_individual_with_no_reg",
                        dropdownoptions
                      )}
                      optionsloading={dropdownloading}
                    />
                    <TaxNumberComponent
                      name={`${props.name}.bo_individual_taxnumber`}
                    />
                  </>
                ) : (
                  <TaxTypeSelectComponent
                    name={`${props.name}.bo_individual_taxtype`}
                    taxoptions={MenuItemsForDropDown(
                      "taxtype_individual_with_no_reg",
                      dropdownoptions
                    )}
                    optionsloading={dropdownloading}
                  />
                )}
                <SelectComponent
                  label="Mobile Code"
                  name={`${props.name}.bo_individual_mobilecode`}
                  required={true}
                  options={MenuItemsForDropDown(
                    "mobilecode",
                    dropdownoptions,
                    false
                  )}
                  optionsloading={dropdownloading}
                />
                <TrustsMobileField
                  name={`${props.name}.bo_individual_mobile`}
                  required={true}
                  label="Mobile Number"
                />
                {formData.values.bo_individuals[props.index]
                  .bo_individual_taxtype !== "99" ? (
                  <EmailFieldComponent
                    name={`${props.name}.bo_individual_email`}
                  />
                ) : (
                  <EmailFieldComponent
                    name={`${props.name}.bo_individual_email`}
                  />
                )}
              </>
            )}
            <AddressUnitNumber
              name={`${props.name}.bo_individual_unitno`}
              label="Unit Number"
            />
            <AddressComplexName
              name={`${props.name}.bo_individual_complexname`}
            />
            <AddressStreetName
              name={`${props.name}.bo_individual_streetname`}
              label="Street"
              required={true}
            />
            <AddressSuburb
              name={`${props.name}.bo_individual_suburb`}
              label="Suburb/District"
              required={true}
              autoComplete="address-level3"
            />
            <AddressCity
              name={`${props.name}.bo_individual_city`}
              label="City/Town"
              required={true}
              autoComplete="address-level2"
            />
            <PostalCode
              name={`${props.name}.bo_individual_postalcode`}
              label="Postal Code"
              required={true}
              autoComplete="postal-code"
            />
          </>
        )}
      </Box>

      <Box sx={{ display: { xs: "none", md: "block" } }}>
        <TableContainer>
          <Table sx={{ width: "100%" }}>
            <TableBody>
              <TableRow>
                <TableCell colSpan={6}>
                  <Button>
                    <u>{`Individual  ${props.index + 1}`}</u>
                  </Button>
                </TableCell>
                <TableCell colSpan={6}></TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <SelectComponent
                    label="Ownership Type"
                    name={`${props.name}.bo_individual_botype`}
                    required={true}
                    options={MenuItemsForDropDown(
                      "individualbeneficialownershiptype",
                      dropdownoptions
                    )}
                    optionsloading={dropdownloading}
                    aria-label={`Individual ${props.index + 1}: Ownership Type`}
                  />
                </TableCell>
                <TableCell>
                  <NameField
                    index={props.index}
                    label="Name"
                    name={`${props.name}.bo_individual_name`}
                    required={true}
                    aria-label={`Individual ${props.index + 1}: Name`}
                  />
                </TableCell>
                <TableCell>
                  <SurnameField
                    label="Surname"
                    name={`${props.name}.bo_individual_surname`}
                    aria-label={`Individual ${props.index + 1}: Surname`}
                    required={true}
                  />
                </TableCell>
                <TableCell>
                  <SelectComponent
                    label="Place of Birth"
                    name={`${props.name}.bo_individual_placeofbirth`}
                    aria-label={`Individual ${props.index + 1}: Place of Birth`}
                    required={true}
                    options={MenuItemsForDropDown(
                      "country",
                      dropdownoptions,
                      false
                    )}
                    optionsloading={dropdownloading}
                  />
                </TableCell>
                <TableCell>
                  <SelectComponent
                    label="Country of Residence"
                    name={`${props.name}.bo_individual_country`}
                    aria-label={`Individual ${
                      props.index + 1
                    }: Country of Residence`}
                    required={true}
                    options={MenuItemsForDropDown(
                      "country",
                      dropdownoptions,
                      false
                    )}
                    optionsloading={dropdownloading}
                  />
                </TableCell>
              </TableRow>
              {formData.values?.bo_individuals[props.index]
                .bo_individual_collapsed ? null : (
                <>
                  {formData.values?.bo_individuals[props.index]
                    .bo_individual_idtype === "1" ? (
                    <>
                      <TableRow>
                        <TableCell>
                          <IDTypeSelectComponent
                            name={`${props.name}.bo_individual_idtype`}
                            aria-label={`Individual ${
                              props.index + 1
                            }: ID Type`}
                            idoptions={MenuItemsForDropDown(
                              "idtype",
                              dropdownoptions
                            )}
                            optionsloading={dropdownloading}
                          />
                        </TableCell>
                        <TableCell>
                          <IDNumberComponent
                            name={`${props.name}.bo_individual_idnumber`}
                            aria-label={`Individual ${
                              props.index + 1
                            }: ID Number`}
                          />
                        </TableCell>
                        {formData.values.bo_individuals[props.index]
                          .bo_individual_taxtype !== "99" ? (
                          <>
                            <TableCell>
                              <TaxTypeSelectComponent
                                name={`${props.name}.bo_individual_taxtype`}
                                aria-label={`Individual ${
                                  props.index + 1
                                }: Tax Type`}
                                taxoptions={MenuItemsForDropDown(
                                  "taxtype_individual_with_no_reg",
                                  dropdownoptions
                                )}
                                optionsloading={dropdownloading}
                              />
                            </TableCell>
                            <TableCell>
                              <TaxNumberComponent
                                name={`${props.name}.bo_individual_taxnumber`}
                                aria-label={`Individual ${
                                  props.index + 1
                                }: Tax Number`}
                              />
                            </TableCell>
                          </>
                        ) : (
                          <TableCell>
                            <TaxTypeSelectComponent
                              name={`${props.name}.bo_individual_taxtype`}
                              aria-label={`Individual ${
                                props.index + 1
                              }: Tax Type`}
                              taxoptions={MenuItemsForDropDown(
                                "taxtype_individual_with_no_reg",
                                dropdownoptions
                              )}
                              optionsloading={dropdownloading}
                            />
                          </TableCell>
                        )}
                        <TableCell>
                          <SelectComponent
                            label="Tax Juristiction"
                            name={`${props.name}.bo_individual_taxjuristiction`}
                            aria-label={`Individual ${
                              props.index + 1
                            }: Tax Juristiction`}
                            required={true}
                            options={MenuItemsForDropDown(
                              "country",
                              dropdownoptions,
                              false
                            )}
                            optionsloading={dropdownloading}
                          />
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <SelectComponent
                            label="Mobile Code"
                            name={`${props.name}.bo_individual_mobilecode`}
                            aria-label={`Individual ${
                              props.index + 1
                            }: Mobile Code`}
                            required={true}
                            options={MenuItemsForDropDown(
                              "mobilecode",
                              dropdownoptions,
                              false
                            )}
                            optionsloading={dropdownloading}
                          />
                        </TableCell>
                        <TableCell>
                          <TrustsMobileField
                            name={`${props.name}.bo_individual_mobile`}
                            aria-label={`Individual ${
                              props.index + 1
                            }: Mobile Number`}
                            required={true}
                            label="Mobile Number"
                          />
                        </TableCell>
                        <TableCell colSpan={3}>
                          <EmailFieldComponent
                            name={`${props.name}.bo_individual_email`}
                            aria-label={`Individual ${props.index + 1}: Email`}
                          />
                        </TableCell>
                      </TableRow>
                    </>
                  ) : (
                    <>
                      <TableRow>
                        <TableCell>
                          <IDTypeSelectComponent
                            name={`${props.name}.bo_individual_idtype`}
                            aria-label={`Individual ${
                              props.index + 1
                            }: ID Type`}
                            idoptions={MenuItemsForDropDown(
                              "idtype",
                              dropdownoptions
                            )}
                            optionsloading={dropdownloading}
                          />
                        </TableCell>
                        <TableCell>
                          <PassportComponent
                            name={`${props.name}.bo_individual_passport`}
                            aria-label={`Individual ${
                              props.index + 1
                            }: Passport`}
                            label="Passport Number"
                          />
                        </TableCell>
                        <TableCell>
                          <SelectComponent
                            label="Passport Country"
                            name={`${props.name}.bo_individual_passportcountry`}
                            aria-label={`Individual ${
                              props.index + 1
                            }: Passport Country`}
                            required={true}
                            options={MenuItemsForDropDown(
                              "country",
                              dropdownoptions,
                              false
                            )}
                            optionsloading={dropdownloading}
                          />
                        </TableCell>
                        <TableCell>
                          <DateSelectorComponent
                            name={`${props.name}.bo_individual_passportdt`}
                            aria-label={`Individual ${
                              props.index + 1
                            }: Passport Date`}
                            label="Issue Date"
                            readonly={true}
                            maxDate={new Date().setDate(new Date().getDate())}
                          />
                        </TableCell>
                        <TableCell>
                          <SelectComponent
                            label="Tax Juristiction"
                            name={`${props.name}.bo_individual_taxjuristiction`}
                            aria-label={`Individual ${
                              props.index + 1
                            }: CTax Juristiction`}
                            required={true}
                            options={MenuItemsForDropDown(
                              "country",
                              dropdownoptions,
                              false
                            )}
                            optionsloading={dropdownloading}
                          />
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        {formData.values.bo_individuals[props.index]
                          .bo_individual_taxtype !== "99" ? (
                          <>
                            <TableCell>
                              <TaxTypeSelectComponent
                                name={`${props.name}.bo_individual_taxtype`}
                                aria-label={`Individual ${
                                  props.index + 1
                                }: Tax Type`}
                                taxoptions={MenuItemsForDropDown(
                                  "taxtype_individual_with_no_reg",
                                  dropdownoptions
                                )}
                                optionsloading={dropdownloading}
                              />
                            </TableCell>
                            <TableCell>
                              <TaxNumberComponent
                                name={`${props.name}.bo_individual_taxnumber`}
                                aria-label={`Individual ${
                                  props.index + 1
                                }: Tax Number`}
                              />
                            </TableCell>
                          </>
                        ) : (
                          <TableCell>
                            <TaxTypeSelectComponent
                              name={`${props.name}.bo_individual_taxtype`}
                              aria-label={`Individual ${
                                props.index + 1
                              }: Tax Type`}
                              taxoptions={MenuItemsForDropDown(
                                "taxtype_individual_with_no_reg",
                                dropdownoptions
                              )}
                              optionsloading={dropdownloading}
                            />
                          </TableCell>
                        )}
                        <TableCell>
                          <SelectComponent
                            label="Mobile Code"
                            name={`${props.name}.bo_individual_mobilecode`}
                            aria-label={`Individual ${
                              props.index + 1
                            }: Mobile Code`}
                            required={true}
                            options={MenuItemsForDropDown(
                              "mobilecode",
                              dropdownoptions,
                              false
                            )}
                            optionsloading={dropdownloading}
                          />
                        </TableCell>
                        <TableCell>
                          <TrustsMobileField
                            name={`${props.name}.bo_individual_mobile`}
                            aria-label={`Individual ${
                              props.index + 1
                            }: Mobile Number`}
                            required={true}
                            label="Mobile Number"
                          />
                        </TableCell>
                        {formData.values.bo_individuals[props.index]
                          .bo_individual_taxtype !== "99" ? (
                          <TableCell>
                            <EmailFieldComponent
                              name={`${props.name}.bo_individual_email`}
                              aria-label={`Individual ${
                                props.index + 1
                              }: Email`}
                            />
                          </TableCell>
                        ) : (
                          <TableCell colSpan={2}>
                            <EmailFieldComponent
                              name={`${props.name}.bo_individual_email`}
                              aria-label={`Individual ${
                                props.index + 1
                              }: Email`}
                            />
                          </TableCell>
                        )}
                      </TableRow>
                    </>
                  )}
                  <TableRow>
                    <TableCell>
                      <AddressUnitNumber
                        name={`${props.name}.bo_individual_unitno`}
                        aria-label={`Individual ${
                          props.index + 1
                        }: Unit Number`}
                        label="Unit Number"
                      />
                    </TableCell>
                    <TableCell>
                      <AddressComplexName
                        name={`${props.name}.bo_individual_complexname`}
                        aria-label={`Individual ${
                          props.index + 1
                        }: Complex Name`}
                      />
                    </TableCell>
                    <TableCell>
                      <AddressStreetName
                        name={`${props.name}.bo_individual_streetname`}
                        aria-label={`Individual ${
                          props.index + 1
                        }: Street Name`}
                        label="Street"
                        required={true}
                      />
                    </TableCell>
                    <TableCell>
                      <AddressSuburb
                        name={`${props.name}.bo_individual_suburb`}
                        aria-label={`Individual ${props.index + 1}: Suburb`}
                        label="Suburb/District"
                        required={true}
                        autoComplete="address-level3"
                      />
                    </TableCell>
                    <TableCell>
                      <AddressCity
                        name={`${props.name}.bo_individual_city`}
                        aria-label={`Individual ${props.index + 1}: City`}
                        label="City/Town"
                        required={true}
                        autoComplete="address-level2"
                      />
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <PostalCode
                        name={`${props.name}.bo_individual_postalcode`}
                        aria-label={`Individual ${
                          props.index + 1
                        }: Postal Code`}
                        label="Postal Code"
                        required={true}
                        autoComplete="postal-code"
                      />
                    </TableCell>
                  </TableRow>
                </>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </>
  ) : (
    <>
      <Box sx={{ display: { xs: "block", md: "none" } }}>
        <Button>
          <u>{`Individual  ${props.index + 1} (UNNAMED)`}</u>
        </Button>
        <SelectComponent
          label="Beneficial Ownership Category"
          name={`${props.name}.bo_individual_unnamed_category`}
          aria-label={`Individual ${props.index + 1}: Beneficial Ownership Category`}
          required={true}
          options={MenuItemsForDropDown("bocategory", dropdownoptions, true)}
        />
        <BODescription
          name={`${props.name}.bo_individual_unnamed_description`}
          aria-label={`Individual ${props.index + 1}: Description`}
          label="Description"
        />
      </Box>
      <Box sx={{ display: { xs: "none", md: "block" } }}>
        <TableContainer>
          <Table sx={{ width: "100%" }}>
            <TableBody>
              <TableRow>
                <TableCell colSpan={6}>
                  <Button>
                    <u>{`Individual  ${props.index + 1} (UNNAMED)`}</u>
                  </Button>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={12}>
                  <SelectComponent
                    label="Beneficial Ownership Category"
                    name={`${props.name}.bo_individual_unnamed_category`}
                    aria-label={`Individual ${props.index + 1}: Beneficial Ownership Category`}
                    required={true}
                    options={MenuItemsForDropDown(
                      "bocategory",
                      dropdownoptions,
                      true
                    )}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={12}>
                  <BODescription
                    name={`${props.name}.bo_individual_unnamed_description`}
                    aria-label={`Individual ${props.index + 1}: Description`}
                    label="Description"
                  />
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </>
  );
};

export default BOIndividualDetails;
